import axios, { AxiosResponse } from 'axios';
import { Category } from '../models/Category';
import { PagingResult } from './../models/PagingResult';
import { WPPost } from './../models/WPPost';

export async function getPosts(page: number = 1, categories: number[] = []): Promise<PagingResult<WPPost>> {
    const url = '/wp-json/wp/v2/posts';
    const params = {
        _embed: '',
        page,
        categories: categories.length > 0 ? categories.join(',') : null,
    };

    return axios.get(url, { params }).then((response: AxiosResponse<WPPost[]>) => {
        const totalPages: number = ~~response.headers['x-wp-totalpages'];
        const totalItems: number = ~~response.headers['x-wp-total'];

        return {
            currentPage: page,
            totalPages,
            totalItems,
            isLastPage: page === totalPages,
            items: response.data,
        };
    });
}

export async function getCategories(): Promise<Category[]> {
    const url = '/wp-json/wp/v2/categories';
    return axios.get(url).then((response: AxiosResponse<Category[]>) => {
        return response.data.filter((c) => c.count > 0);
    });
}
